import React, { useContext, useEffect, useState } from 'react'
import SockJsClient from 'react-stomp'
import moment from 'moment'
import { gsap } from 'gsap'
import {
  Badge,
  Button,
  DatePicker,
  message,
  Modal,
  notification,
  Popover,
  Select,
} from 'antd'
import { LogoutOutlined, KeyOutlined } from '@ant-design/icons'
import './menu.scss'
import Logo from './../img/logo.svg'
import Sun from './../img/Sun.svg'
import Bell from './../img/Bell.svg'
import Moon from './../img/moon.svg'
import DarkBell from './../img/DarkBell.svg'
import $api from '../service/http'
import { TriggerContext } from '../context'
import { useHistory } from 'react-router'
const { RangePicker } = DatePicker
const { Option } = Select

function Menu() {
  const history = useHistory()
  const [bell, setBell] = useState(Bell)
  const [sun, setSun] = useState(Sun)
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [Notifications, setNotifications] = useState([])
  const [UserNotification, setUserNotification] = useState([])
  const [Archive, setArchive] = useState([])
  const [objrooms, setobjrooms] = useState([])
  const [Selectvalue, setSelectvalue] = useState(objrooms[0]?.id)
  const { trigger, setTrigger } = useContext(TriggerContext)
  const [count, setCount] = useState(1)
  const [page, setPage] = useState(15)
  const [ArchiveButton, setArchiveButton] = useState(false)
  const [ApiCount, setApiCount] = useState(null)
  const [BushXonalar, setBushXonalar] = useState([
    moment().format('MM.DD.YYYY'),
    moment().add(7, 'days').format('MM.DD.YYYY'),
  ])
  const Bushlar = () => {
    history.push(
      '/booking/room/?startDate=' +
        moment(BushXonalar[0]).format('DD.MM.YYYY') +
        '&finishDate=' +
        moment(BushXonalar[1]).format('DD.MM.YYYY') +
        ''
    )
    // $api
    //   .post(
    //     '/booking?startDate=' +
    //       moment(BushXonalar[0]).format('DD.MM.YYYY') +
    //       '&finishDate=' +
    //       moment(BushXonalar[1]).format('DD.MM.YYYY') +
    //       '',
    //     {},
    //     {
    //       auth: {
    //         username: localStorage.getItem('username'),
    //         password: localStorage.getItem('password'),
    //       },
    //     }
    //   )
    //   .then((res) => {
    //     console.log(res.data.data.floors)
    //   })
    //   .catch((error) => {
    //     console.log(error?.response?.data?.message)
    //   })
  }
  useEffect(() => {
    $api
      .post(
        '/notification/count',
        {},
        {
          auth: {
            username: localStorage.getItem('username'),
            password: localStorage.getItem('password'),
          },
        }
      )
      .then((res) => {
        setApiCount(res.data.data)
      })
      .catch((error) => {
        console.log(error?.response?.data?.message)
      })
  }, [trigger])
  const XonadonBandQilish = (e) => {
    $api
      .post(
        '/notification/' + e + '',
        {},
        {
          auth: {
            username: localStorage.getItem('username'),
            password: localStorage.getItem('password'),
          },
        }
      )
      .then((res) => {
        console.log(objrooms)
        setArchiveButton(false)
        setobjrooms([])
        if (res.data.data.rooms.length === 0) {
          message.error(res.data.message)
          setUserNotification(res.data.data)
        } else {
          setUserNotification(res.data.data)
          setobjrooms(res.data.data.rooms)
          setSelectvalue(res.data.data.rooms[0].id)
        }
      })
      .catch((error) => {
        message.error(error?.response?.data?.message)
      })
    setIsModalVisible(true)
  }
  const XonadonBandQilishArchive = (e) => {
    $api
      .post(
        '/notification/' + e + '',
        {},
        {
          auth: {
            username: localStorage.getItem('username'),
            password: localStorage.getItem('password'),
          },
        }
      )
      .then((res) => {
        console.log(res.data)
        setArchiveButton(true)
        if (res.data.data.rooms.length === 0) {
          setUserNotification(res.data.data)
        } else {
          setUserNotification(res.data.data)
          setobjrooms(res.data.data.rooms)
          setSelectvalue(res.data.data.rooms[0].id)
        }
      })
      .catch((error) => {
        message.error(error?.response?.data?.message)
      })
    setIsModalVisible(true)
  }

  const handleOk = (e) => {
    console.log(e, Number(Selectvalue))

    $api
      .post(
        '/booking/success?notificationId=' +
          e +
          '&roomId=' +
          Number(Selectvalue) +
          '',
        {},
        {
          auth: {
            username: localStorage.getItem('username'),
            password: localStorage.getItem('password'),
          },
        }
      )
      .then((res) => {
        message.success(res.data.message)
        setTrigger(e)
      })
      .catch((error) => {
        message.error(error?.response?.data?.message)
      })
    setIsModalVisible(false)
  }

  const handleCancel = (e) => {
    $api
      .post(
        '/notification/archive/' + e + '',
        {},
        {
          auth: {
            username: localStorage.getItem('username'),
            password: localStorage.getItem('password'),
          },
        }
      )
      .then((res) => {
        setUserNotification(res.data.data)
        message.success(res.data.message)
        setTrigger(e)
      })
      .catch((error) => {
        message.error(error.response.data.message)
      })
    setIsModalVisible(false)
  }

  const barchasi = (e) => {
    setCount(1)
    e.target.classList.toggle('active')
    document.querySelector('main').classList.toggle('active')
    document.querySelector('.main2').classList.toggle('active')
  }

  useEffect(() => {
    $api
      .post(
        '/notification/archive?page=' + count + '&size=' + page + '',
        {},
        {
          auth: {
            username: localStorage.getItem('username'),
            password: localStorage.getItem('password'),
          },
        }
      )
      .then((res) => {
        setArchive(res.data.data)
      })
      .catch((error) => {
        message.error(error.response.data.message)
      })
  }, [count, page])

  const Notification = () => {
    let notification = document.querySelector('.notification')
    notification.classList.toggle('active')
    if (notification.className === 'notification active') {
      notification.style.display = 'block'
      setTimeout(function () {
        gsap.to('.notification>div:nth-child(1)', 0.3, { opacity: 1 })
        gsap.to('.notification>div:nth-child(2)', 0.2, { x: 0 })
        gsap.to('.notification', 0.2, { opacity: 1 })
      })
    } else {
      gsap.to('.notification>div:nth-child(1)', 0.3, { opacity: 0 })
      gsap.to('.notification>div:nth-child(2)', 0.2, { x: '100%' })
      gsap.to('.notification', 0.2, { opacity: 0 })
      setTimeout(function () {
        notification.style.display = 'none'
      }, 200)
    }
  }
  useEffect(() => {
    $api
      .post(
        '/notification?page=' + count + '&size=' + page + '',
        {},
        {
          auth: {
            username: localStorage.getItem('username'),
            password: localStorage.getItem('password'),
          },
        }
      )
      .then((res) => {
        setNotifications(res.data.data)
      })
      .catch((error) => {
        message.error(error.response.data.message)
      })
  }, [trigger, count, page])
  const dark = (e) => {
    document.body.classList.toggle('dark')
    if (document.body.className === 'dark') {
      localStorage.setItem('body', 'dark')
      setBell(DarkBell)
      setSun(Moon)
    } else {
      localStorage.setItem('body', '')
      setBell(Bell)
      setSun(Sun)
    }
  }
  useEffect(() => {
    if (localStorage.getItem('body') === 'dark') {
      localStorage.setItem('body', 'dark')
      document.body.className = 'dark'
      setBell(DarkBell)
      setSun(Moon)
    } else {
      document.body.className = ''
      localStorage.setItem('body', '')
      setBell(Bell)
      setSun(Sun)
    }
  }, [])
  return (
    <div className='tinchlikplaza_bron_menu'>
      <SockJsClient
        url={'https://tinchlikplaza.softex.uz/ws'}
        topics={['/booking/none']}
        headers={{ auth: 'Basic admin admin' }}
        onDisconnect={(e) => {
          console.log('disconnect', e)
        }}
        onConnect={(e) => {
          console.log('connect', e)
        }}
        onMessage={(e, a, b) => {
          setTrigger(e)
          notification.open({
            message: 'Bildirishnoma',
            description: (
              <>
                <div
                  onClick={() => XonadonBandQilish(e.id)}
                  className='notificationSoket'
                >
                  <h3>{e.createTime.replace('T', ' ')}</h3>
                  <div>
                    <div>
                      <h1>{e.roomType}</h1>
                      <p>Xona</p>
                      <h1>{e.capacity} xonali</h1>
                    </div>
                    <div>
                      <p>kelish sanasi</p>
                      <h1>{e.startedDate}</h1>
                      <p>ketish sanasi</p>
                      <h1>{e.finishedDate}</h1>
                    </div>
                  </div>
                </div>
              </>
            ),
            placement: 'bottomRight',
          })
        }}
      />
      <img src={Logo} alt='Logo' />
      <div>
        <Popover
          content={
            <>
              <RangePicker
                defaultValue={[moment(BushXonalar[0]), moment(BushXonalar[1])]}
                onChange={(i, e) => {
                  setBushXonalar(e)
                }}
              />
              <Button
                onClick={Bushlar}
                type='primary'
                style={{ display: 'block', margin: '10px auto 0' }}
              >
                Qidirish
              </Button>
            </>
          }
          title="Bo'sh xonalar"
          trigger='click'
        >
          <Button>
            <KeyOutlined />
          </Button>
        </Popover>
        <Button onClick={() => history.push('/admin/logout')}>
          <LogoutOutlined />
        </Button>
        <button onClick={dark}>
          <img src={sun} alt='Sun' />
        </button>
        <button onClick={Notification}>
          <Badge count={ApiCount}>
            <img className='bell' src={bell} alt='Bell' />
          </Badge>
        </button>
      </div>
      <div className='notification'>
        <Modal
          maskStyle={{ background: 'transparent' }}
          wrapClassName='notification_modal'
          title='Xona band qilish'
          visible={isModalVisible}
          onCancel={() => setIsModalVisible(false)}
          okText={'Tasdiqlash'}
          cancelText={'Bekor qilish'}
          footer={false}
        >
          <div>
            <div>
              <div>
                <p>Familiya</p>
                <h3>{UserNotification.firstname}</h3>
              </div>
              <div>
                <p>Ism</p>
                <h3>{UserNotification.lastname}</h3>
              </div>
              <div>
                <p>Telefon</p>
                <h3>{UserNotification.phone}</h3>
              </div>
            </div>
            <div>
              <div>
                <p>Fuqaroligi</p>
                <h3>
                  {UserNotification.resident === true ? (
                    <span>O'zbekistonlik</span>
                  ) : (
                    <span>O'zbekistonlik emas</span>
                  )}
                </h3>
              </div>
            </div>
            <div>
              <div>
                <p>E-pochta</p>
                <h3>{UserNotification.email}</h3>
              </div>
            </div>
          </div>
          <div>
            <div>
              <p>Band qilingan sana</p>
              <p>
                <span>{UserNotification.startedDate}</span> dan
                <span>{UserNotification.finishedDate}</span> gacha
              </p>
              <p>Tanlangan xona turi</p>
              <h1>{UserNotification.roomType}</h1>
              <p>Xona tanlash</p>
              <div>
                {objrooms[0]?.number && (
                  <Select
                    onChange={(value) => setSelectvalue(value)}
                    defaultValue={objrooms[0]?.number}
                    style={{ width: 100 }}
                  >
                    {objrooms.map((room) => {
                      return (
                        <Option key={room.id} value={room.id}>
                          {room.number}
                        </Option>
                      )
                    })}
                  </Select>
                )}
              </div>
            </div>
            <div>
              <p>Xona</p>
              <h1>{UserNotification.capacity} xonali</h1>
              <p>Narxi</p>
              <h1>{UserNotification.fullPrice?.toLocaleString()} so'm</h1>
              <p>To'lov turi</p>
              <h1>
                {UserNotification.paymentType === 'NONE'
                  ? "To'lovsiz"
                  : UserNotification.paymentType}
                {UserNotification.paymentStatus === 'NONE'
                  ? ''
                  : `(${UserNotification.paymentStatus})`}
              </h1>
            </div>
          </div>
          <div>
            {ArchiveButton === false ? (
              <>
                {UserNotification.paymentStatus === 'SUCCESS' ? (
                  <button style={{ display: 'none' }}></button>
                ) : (
                  <button onClick={() => handleCancel(UserNotification.id)}>
                    Bekor qilish
                  </button>
                )}
                <button onClick={() => handleOk(UserNotification.id)}>
                  Tasdiqlash
                </button>
              </>
            ) : null}
          </div>
        </Modal>
        <div onClick={Notification}></div>
        <div>
          <div>
            <div className='main3'>
              {/* {MessageNotification.map((messagenotification) => {
                return (
                  <div
                    key={messagenotification.id}
                    onClick={() => XonadonBandQilish(messagenotification.id)}
                    style={{ border: '1px solid blue' }}
                  >
                    <span className='apartament_close'>
                      <svg
                        width='12'
                        height='12'
                        viewBox='0 0 12 12'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <path
                          d='M9.375 2.625L2.625 9.375'
                          stroke='#696969'
                          strokeLinecap='round'
                          strokeLinejoin='round'
                        />
                        <path
                          d='M9.375 9.375L2.625 2.625'
                          stroke='#696969'
                          strokeLinecap='round'
                          strokeLinejoin='round'
                        />
                      </svg>
                    </span>
                    <h3>{messagenotification.createTime.replace('T', ' ')}</h3>
                    <div>
                      <div>
                        <h1>{messagenotification.roomType}</h1>
                        <p>Xona</p>
                        <h1>{messagenotification.capacity} xonali</h1>
                      </div>
                      <div>
                        <p>kelish sanasi</p>
                        <h1>{messagenotification.startedDate}</h1>
                        <p>ketish sanasi</p>
                        <h1>{messagenotification.finishedDate}</h1>
                      </div>
                    </div>
                  </div>
                )
              })} */}
            </div>
            <div className='main2 active'>
              {Notifications.map((notificat) => {
                return (
                  <div
                    key={notificat.id}
                    onClick={() => XonadonBandQilish(notificat.id)}
                  >
                    <span className='apartament_close'>
                      <svg
                        width='12'
                        height='12'
                        viewBox='0 0 12 12'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <path
                          d='M9.375 2.625L2.625 9.375'
                          stroke='#696969'
                          strokeLinecap='round'
                          strokeLinejoin='round'
                        />
                        <path
                          d='M9.375 9.375L2.625 2.625'
                          stroke='#696969'
                          strokeLinecap='round'
                          strokeLinejoin='round'
                        />
                      </svg>
                    </span>
                    <h3>{notificat.createTime.replace('T', ' ')}</h3>
                    <div>
                      <div>
                        <h1>{notificat.roomType}</h1>
                        <p>Xona</p>
                        <h1>{notificat.capacity} xonali</h1>
                      </div>
                      <div>
                        <p>kelish sanasi</p>
                        <h1>{notificat.startedDate}</h1>
                        <p>ketish sanasi</p>
                        <h1>{notificat.finishedDate}</h1>
                      </div>
                    </div>
                  </div>
                )
              })}
            </div>
            <main>
              {Archive.map((archiv) => {
                return (
                  <div
                    key={archiv.id}
                    style={{ border: '1px solid red' }}
                    onClick={() => XonadonBandQilishArchive(archiv.id)}
                  >
                    <span className='apartament_close'>
                      <svg
                        width='12'
                        height='12'
                        viewBox='0 0 12 12'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <path
                          d='M9.375 2.625L2.625 9.375'
                          stroke='#696969'
                          strokeLinecap='round'
                          strokeLinejoin='round'
                        />
                        <path
                          d='M9.375 9.375L2.625 2.625'
                          stroke='#696969'
                          strokeLinecap='round'
                          strokeLinejoin='round'
                        />
                      </svg>
                    </span>
                    <h3>{archiv.createTime.replace('T', ' ')}</h3>
                    <div>
                      <div>
                        <h1>{archiv.roomType}</h1>
                        <p>Xona</p>
                        <h1>{archiv.capacity} xonali</h1>
                      </div>
                      <div>
                        <p>kelish sanasi</p>
                        <h1>{archiv.startedDate}</h1>
                        <p>ketish sanasi</p>
                        <h1>{archiv.finishedDate}</h1>
                      </div>
                    </div>
                  </div>
                )
              })}
            </main>
          </div>
          <div>
            <button
              onClick={() => {
                if (count === 1) {
                } else {
                  setCount(count - 1)
                }
              }}
            >
              {'<'}-
            </button>
            {count}
            <button onClick={() => setCount(count + 1)}>-{'>'}</button>
          </div>
          <div>
            <Select
              defaultValue='15'
              onChange={(value) => {
                setPage(value)
              }}
            >
              <Option value='10'>10</Option>
              <Option value='15'>15</Option>
              <Option value='20'>20</Option>
              <Option value='25'>25</Option>
              <Option value='30'>30</Option>
              <Option value='35'>35</Option>
              <Option value='40'>40</Option>
              <Option value='45'>45</Option>
              <Option value='50'>50</Option>
            </Select>
            <button onClick={barchasi}>
              <svg
                width='19'
                height='18'
                viewBox='0 0 19 18'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M10.75 4.50008V8.56707L14.2721 10.6006C14.3574 10.6498 14.4322 10.7154 14.4921 10.7935C14.5521 10.8717 14.5961 10.9608 14.6216 11.056C14.647 11.1511 14.6536 11.2503 14.6407 11.348C14.6278 11.4456 14.5959 11.5398 14.5466 11.6251C14.4974 11.7104 14.4318 11.7851 14.3537 11.8451C14.2755 11.9051 14.1864 11.949 14.0912 11.9745C13.9961 12 13.8969 12.0065 13.7992 11.9937C13.7016 11.9808 13.6074 11.9489 13.5221 11.8996L9.62498 9.6496C9.61899 9.64614 9.61363 9.64206 9.60777 9.63846C9.59505 9.63062 9.58237 9.62273 9.57019 9.61417C9.56049 9.60739 9.55124 9.60021 9.54195 9.59304C9.53238 9.58566 9.52286 9.57826 9.5137 9.57043C9.50322 9.56155 9.49329 9.5523 9.48344 9.54293C9.47603 9.53587 9.46866 9.52881 9.46152 9.52145C9.45149 9.51113 9.44197 9.5005 9.43263 9.48967C9.42613 9.48215 9.41972 9.4746 9.4135 9.46682C9.40489 9.45598 9.3967 9.44493 9.38873 9.43368C9.38242 9.4248 9.37624 9.41585 9.37033 9.40669C9.36356 9.39619 9.35715 9.38555 9.35092 9.37476C9.34474 9.36403 9.33875 9.35321 9.33307 9.34215C9.32808 9.33239 9.32337 9.32252 9.31884 9.31256C9.31312 9.30011 9.30767 9.28755 9.30259 9.27474C9.29892 9.26537 9.29554 9.25593 9.29224 9.24643C9.28757 9.23307 9.28318 9.21963 9.27928 9.20593C9.27645 9.19591 9.27397 9.18582 9.2715 9.17569C9.26839 9.16263 9.26537 9.14955 9.26294 9.13623C9.2607 9.1242 9.25905 9.11209 9.2574 9.09994C9.25585 9.08848 9.25429 9.07706 9.25328 9.06544C9.25196 9.05043 9.25145 9.03536 9.251 9.02026C9.25081 9.0135 9.24998 9.0069 9.24998 9.00008V4.50008C9.24998 4.30117 9.329 4.11041 9.46966 3.96975C9.61031 3.8291 9.80107 3.75008 9.99998 3.75008C10.1989 3.75008 10.3897 3.8291 10.5303 3.96975C10.671 4.11041 10.75 4.30117 10.75 4.50008ZM16.3639 2.63612C14.6748 0.950771 12.3861 0.00427246 9.99996 0.00427246C7.61384 0.00427246 5.32515 0.950771 3.63602 2.63612L2.85933 3.41278L1.51469 2.06812C1.40981 1.96323 1.27617 1.8918 1.13069 1.86286C0.9852 1.83391 0.8344 1.84876 0.697355 1.90553C0.56031 1.96229 0.443176 2.05842 0.360766 2.18176C0.278356 2.3051 0.234371 2.45011 0.234375 2.59844V6.34844C0.234372 6.44693 0.25377 6.54446 0.29146 6.63546C0.32915 6.72645 0.384394 6.80913 0.454039 6.87878C0.523683 6.94842 0.606364 7.00367 0.697359 7.04136C0.788355 7.07905 0.885883 7.09844 0.984375 7.09844H4.73438C4.88271 7.09845 5.02772 7.05446 5.15106 6.97205C5.27439 6.88964 5.37052 6.77251 5.42729 6.63546C5.48406 6.49842 5.49891 6.34762 5.46996 6.20213C5.44102 6.05664 5.36959 5.92301 5.26469 5.81812L3.92002 4.47344L4.6967 3.69675C5.7456 2.64785 7.08198 1.93354 8.53684 1.64415C9.9917 1.35476 11.4997 1.50328 12.8702 2.07094C14.2406 2.6386 15.412 3.59989 16.2361 4.83327C17.0602 6.06664 17.5001 7.5167 17.5001 9.00006C17.5001 10.4834 17.0602 11.9335 16.2361 13.1669C15.412 14.4002 14.2406 15.3615 12.8702 15.9292C11.4997 16.4968 9.9917 16.6454 8.53684 16.356C7.08198 16.0666 5.7456 15.3523 4.6967 14.3034C4.55604 14.1627 4.36527 14.0837 4.16635 14.0837C3.96742 14.0837 3.77665 14.1627 3.63599 14.3034C3.49534 14.4441 3.41632 14.6348 3.41633 14.8337C3.41633 15.0327 3.49535 15.2234 3.63602 15.3641C5.32385 17.0519 7.61304 18.0001 9.99999 18.0001C12.3869 18.0001 14.6761 17.0519 16.364 15.3641C18.0518 13.6762 19 11.387 19 9.00008C19 6.61312 18.0517 4.32394 16.3639 2.63612Z'
                  fill='#3B037A'
                />
              </svg>
              Arxivni ko’rish
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Menu
